import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import Button from '@mui/material/Button'

import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../../Services/BackEndAPI'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import InputText from '../../../DevComponents/InputText'
import { DeviceInterface } from '../../../ImportBackend/Interfaces/DeviceInterfaces'
import { DeviceStatusType, DeviceStatusTypes } from '../../../ImportBackend/types/ConstantesDataTypes'

interface PesquisaInterface {
  filtro: string
}

export default function DevicesResumo () {

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const clsApi: BackEndAPI = new BackEndAPI()

  const navigate = useNavigate()

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>( { filtro: '' } )

  const [rsDevices, setRsDevices] = useState<Array<DeviceInterface>>( [] )

  const [pesquisou, setPesquisou] = useState( false )

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'hostname',
      cabecalho: 'Hostname',
      alinhamento: 'left'
    },
    {
      campo: 'ip',
      cabecalho: 'IP',
      alinhamento: 'left'
    },
    {
      campo: 'macAddress',
      cabecalho: 'MAC Address',
      alinhamento: 'left'
    },
    {
      campo: 'status',
      cabecalho: 'Status',
      alinhamento: 'left',
      format: ( v ) => DeviceStatusTypes.find( status => status.idStatus === v )?.descricao || v
    },
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    },
    {
      campo: 'observacao',
      cabecalho: 'Observação',
      alinhamento: 'left'
    }
  ]

  const onClickPesquisa = () => {

    const query = `
      getDevicesResumo(pesquisa: "${pesquisa.filtro}") {
        idDevice
        hostname
        ip
        macAddress
        status
        descricao
        observacao
      }
    `

    clsApi.query<Array<DeviceInterface>>( query, 'getDevicesResumo', 'Pesquisando Devices...', contexto ).then( rs => {
      setRsDevices( rs )
      setPesquisou( true )
    } )

  }

  const qtdAtivos = rsDevices.filter( d => d.status === DeviceStatusType.ATIVO ).length
  const qtdInativos = rsDevices.filter( d => d.status === DeviceStatusType.INATIVO ).length

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Resumo de Devices
              </Typography>

              <IconButton onClick={() => navigate( '/' )}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sm={10} sx={{ mb: 3 }}>
              <InputText
                dados={pesquisa}
                field='filtro'
                label='Filtro'
                setState={setPesquisa}
                iconeEnd="search"
                onClickIconeEnd={() => onClickPesquisa()}
                mapKeyPress={[{ key: 'Enter', onKey: onClickPesquisa }]}
              />
            </Grid>

            <Grid item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: { xs: 'right', sm: 'center' } }}>
              <Button variant='contained' onClick={() => onClickPesquisa()}>Pesquisar</Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 1 }}>
              <DataTable dados={rsDevices} cabecalho={Cabecalho} />
            </Grid>

            {pesquisou &&
              <Grid item xs={12} sx={{ mt: 3 }}>
                <Typography variant="body1">Devices Ativos: {qtdAtivos}</Typography>
                <Typography variant="body1">Devices Inativos: {qtdInativos}</Typography>
                <Typography variant="body1">Total de Devices Cadastrados: {rsDevices.length}</Typography>
              </Grid>
            }

          </Grid>
        </Paper>

      </Container>
    </>
  )

}
